import React, { useState, useRef } from "react";
import "./Accordion.css";

const Accordion = ({ sections }) => {
  const [openIndex, setOpenIndex] = useState(null);
  const contentRefs = useRef([]);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <div className="accordion">
      {sections.map((sec, i) => (
        <div key={i} className="accordion-item">
          <button className="accordion-header" onClick={() => toggle(i)}>
            <span>{sec.title}</span>
            <span className={`arrow ${openIndex === i ? "open" : ""}`}>⌄</span>
          </button>

          <div
            ref={(el) => (contentRefs.current[i] = el)}
            className={`accordion-content ${openIndex === i ? "open" : ""}`}
            style={{
              maxHeight:
                openIndex === i
                  ? `${contentRefs.current[i]?.scrollHeight}px`
                  : "0px",
            }}
          >
            {sec.content}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Accordion;
